import {
    JSONSchema7,
    // JSONSchema7Definition
} from 'json-schema';
import { types as coreTypes } from '@sitebuilder/core';
import { TextSchemaWidgetProperties } from './CustomSchemas/TextSchema';
import { LayoutSchemaWidgetProperties } from './CustomSchemas/LayoutSchema';
import { StyleSchemaWidgetProperties } from './CustomSchemas/StyleSchema';

export interface IWidget {
    id: string;
    description?: string;
    group?: string;
    icon?: string;
    /**
     * the schema of widget's properties, used to create
     * the property editor component
     */
    schema: JSONSchema7 | ((props: any) => JSONSchema7);
    uiSchema?: Record<string, unknown>;

    /**
     * the view component of the widget
     */
    templateView: React.FC<any>;
    initialData: (context?: Record<string, unknown>) => Record<string, unknown>;
    contentPlaceHolders: string[];
    isWidgetLibComp?: boolean;
}

export interface WidgetInstanceProps {
    widgetInstanceId?: string;
    storyData?: object;
    data?: Record<string, unknown>;
    theme?: string;
    properties?: any;
}

// export interface WidgetProps extends coreTypes.SchemaProperties {
//     transformDataWithGlobals?: (
//         transformFunctionName: string,
//         functionToTransform: string | undefined,
//         args: any
//     ) => any;
//     properties?: any;
//     i18n?: any;
//     location?: any;
//     annotator?: any;
//     Placeholder?: any;
//     widgetInstance?: coreTypes.WidgetInstance;
//     theme?: string;

//     widgetInstanceId?: string;
//     storyData?: object;
//     data?: Record<string, unknown>;
// }

export interface WidgetPropertiesBase
    extends TextSchemaWidgetProperties,
        LayoutSchemaWidgetProperties,
        StyleSchemaWidgetProperties {
    styles: string;
    data: Record<string, unknown>;
}

export interface IWidgetFactory {
    getWidget: (id: string) => IWidget | null;
    listWidgetIds: () => string[];
}

export class NoOpWidgetFactory implements IWidgetFactory {
    getWidget(_id: string): IWidget | null {
        return null;
    }

    listWidgetIds(): string[] {
        return [];
    }
}

// we need to define this here becuase it is used both by viewer and editor
// but this interface only has the common properties used by both.
// for actual properties used by viewer and editor, see respective components
export interface RootDocumentWidgetPropertiesBase {
    documentType: 'web' | 'pdf' | 'pptx';
    fonts: { name: string; url: string; format: string }[];
    resourceStrings: coreTypes.Resource;
    themes?: {
        id: string;
        conditionFunction: string;
        themeStyles: string;
        colorPallete: string[];
    }[];
    theme: string;
    isDynamicTheme: boolean;
    functionToSelectTheme: string;
    colorSpace: coreTypes.ColorScheme;
}
